import { useMemo } from 'react';

import { useCookiesConsentManagerContext } from '@pflegia/ui/contexts/cookies-consent-manager.context';
import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

const getStoredMarketingAndAnalyticsConsent = () => {
  try {
    return JSON.parse(cookieStorage.getItem('tracking-preferences') || '{}').custom?.marketingAndAnalytics === true;
  } catch {
    return false;
  }
};

const useIsAnalyticsAllowed = () => {
  const { ready, cookiesSettings } = useCookiesConsentManagerContext();
  return useMemo(
    () => (ready ? Boolean(cookiesSettings.marketingAndAnalytics) : getStoredMarketingAndAnalyticsConsent()),
    [ready, cookiesSettings.marketingAndAnalytics],
  );
};

export default useIsAnalyticsAllowed;
